export const SAVE_SUBSCRIBED_USER = 'admin/SAVE_SUBSCRIBED_USER';
export const SAVE_SUBSCRIBED_USER_SUCCESS =
  'admin/SAVE_SUBSCRIBED_USER_SUCCESS';
export const SAVE_SUBSCRIBED_USER_FAILED = 'admin/SAVE_SUBSCRIBED_USER_FAILED';

export const UPDATE_SUBSCRIBED_USER = 'admin/UPDATE_SUBSCRIBED_USER';
export const UPDATE_SUBSCRIBED_USER_SUCCESS =
  'admin/UPDATE_SUBSCRIBED_USER_SUCCESS';
export const UPDATE_SUBSCRIBED_USER_FAILED =
  'admin/UPDATE_SUBSCRIBED_USER_FAILED';

export const GET_SUBSCRIBED_USER = 'admin/GET_SUBSCRIBED_USER';
export const GET_SUBSCRIBED_USER_SUCCESS = 'admin/GET_SUBSCRIBED_USER_SUCCESS';
export const GET_SUBSCRIBED_USER_FAILED = 'admin/GET_SUBSCRIBED_USER_FAILED';

export const GET_SUBSCRIBED_USERS = 'admin/GET_SUBSCRIBED_USERS';
export const GET_SUBSCRIBED_USERS_SUCCESS =
  'admin/GET_SUBSCRIBED_USERS_SUCCESS';
export const GET_SUBSCRIBED_USERS_FAILED = 'admin/GET_SUBSCRIBED_USERS_FAILED';

export const DELETE_SUBSCRIBED_USER = 'admin/DELETE_SUBSCRIBED_USERS';
export const DELETE_SUBSCRIBED_USER_SUCCESS =
  'admin/DELETE_SUBSCRIBED_USERS_SUCCESS';
export const DELETE_SUBSCRIBED_USER_FAILED =
  'admin/DELETE_SUBSCRIBED_USERS_FAILED';

export const GENERATE_PDF = 'admin/GENERATE_PDF';
export const GENERATE_PDF_SUCCESS = 'admin/GENERATE_PDF_SUCCESS';
export const GENERATE_PDF_FAILED = 'admin/GENERATE_PDF_FAILED';

export const GET_PDF_STATUS = 'admin/GET_PDF_STATUS';
export const GET_PDF_STATUS_SUCCESS = 'admin/GET_PDF_STATUS_SUCCESS';
export const GET_PDF_STATUS_FAILED = 'admin/GET_PDF_STATUS_FAILED'

export const GET_PDFS = 'admin/GET_PDFS';
export const GET_PDFS_SUCCESS = 'admin/GET_PDFS_SUCCESS';
export const GET_PDFS_SUCCESS_FAILED = 'admin/GET_PDFS_SUCCESS_FAILED'


export const DELETE_PDF = 'admin/DELETE_PDF';
export const DELETE_PDF_SUCCESS = 'admin/DELETE_PDF_SUCCESS';
export const DELETE_PDF_FAILED = 'admin/DELETE_PDF_FAILED'
